<template>
  <div style="position: relative" :style="buttonStyle">
    <div class="laptop-frame">
      <img src="https://fastforge-dev.s3.amazonaws.com/images/catalog/mgukncl52fgwr" />
    </div>

    <div class="laptop-body" style="font-family: inherit">
      <div class="header-mob">
        <!-- Logo -->
        <div class="app-logo">
          <img
           :src="appIcon || 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSmMFUr4TWHqkYckkiJqqEqBFqYy9gQKQ7N3w&s'"
  alt="Logo"
          />
        </div>

        <!-- Search Bar -->
        <div class="search-bar">
          <input type="text" placeholder="Search for toys & games..." />
          <button><i class="fa fa-search"></i></button>
        </div>

        <!-- Icons -->
        <div class="header-icons">
          <i v-if="headerWishlistIcon" class="fa fa-heart-o"></i>
          <i v-if="headerCartIcon" class="fa fa-shopping-bag"></i>
          <i class="fa fa-user-o"></i>
        </div>
      </div>
      <div class="body-mob" :style="`color:${primaryTextColor};`">
        <div class="advertisement">
          <img
            src="https://fastforge-dev.s3.amazonaws.com/images/catalog/mgukncl52fgwr"
            alt=""
            class="sales-advertisement"
          />
          <!-- <div class="label-1">One App for all your needs!</div>
          <div class="label-2">
            Enjoy your Shopping with <span>{{ appName }}</span
            >!
          </div> -->
        </div>
      </div>
      <div class="toy-categories">
        <div class="header-section">
          <h1 class="title">Toy Categories</h1>
          <p class="subtitle">
            Explore our magical collection of toys by category!
          </p>
        </div>

        <div class="carousel-container">
          <button class="carousel-btn left" @click="previousSlide">‹</button>

          <div class="categories-grid">
            <div
              v-for="(category, index) in visibleCategories"
              :key="category.id"
              class="category-item"
            >
              <div
                class="category-circle"
                :style="{ borderColor: category.color }"
              >
                <img
                  :src="category.icon"
                  :alt="category.name"
                  class="category-icon"
                />
              </div>
              <h3 class="category-name">{{ category.name }}</h3>
            </div>
          </div>

          <button class="carousel-btn right" @click="nextSlide">›</button>
        </div>

        <div class="carousel-dots">
          <span
            v-for="dotIndex in totalDots"
            :key="dotIndex"
            class="dot"
            :class="{ active: currentDot === dotIndex - 1 }"
            @click="goToDot(dotIndex - 1)"
          ></span>
        </div>
      </div>
      <div class="amazing-toys-section">
        <!-- Header -->
        <div class="section-header">
          <h2 class="section-title">Amazing Toys</h2>
          <button class="see-more-btn">
            See More Magic<i
              class="fas fa-arrow-right"
              :style="`padding-left: 3px`"
            ></i>
          </button>
        </div>

        <!-- Toys Row -->
        <div class="toys-row">
          <div v-for="toy in toys" :key="toy.id" class="toy-card">
            <div class="toy-image">
              <img :src="toy.image" :alt="toy.name" />
              <!-- Action buttons -->
              <div class="action-btns">
                <button class="like-btn">❤</button>
                <button class="view-btn">👁</button>
              </div>
            </div>

            <!-- Details -->
            <div class="toy-details">
              <h3 class="toy-name">{{ toy.name }}</h3>
              <span class="toy-seller">{{ toy.seller }}</span>
              <p class="toy-price">${{ toy.price }}</p>

              <!-- Ratings -->
              <div class="toy-rating">
                <span v-for="star in 5" :key="star" class="star">{{
                  star <= toy.rating ? "★" : "☆"
                }}</span>
                <span class="rating-value">{{ toy.rating.toFixed(1) }}</span>
                <span class="rating-count">({{ toy.reviews }})</span>
              </div>

              <!-- Add to Cart -->
              <button class="cart-btn">
                🛒 ADD TO CART <br />
                <small>Tap to add</small>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="body-mob" :style="`color:${primaryTextColor};`">
        <div class="advertisement">
          <img
            src="https://fastforge-dev.s3.amazonaws.com/images/catalog/mgukncl52fgwr"
            alt=""
            class="sales-advertisement"
          />
          <!-- <div class="label-1">One App for all your needs!</div>
          <div class="label-2">
            Enjoy your Shopping with <span>{{ appName }}</span
            >!
          </div> -->
        </div>
      </div>
      <div class="trending-toys">
        <!-- Section Heading -->
        <div class="trending-header">
          <h2>Trending Toys</h2>
          <p>Everyone's loving these amazing toys!</p>
        </div>

        <!-- Cards Wrapper -->
        <div class="toys-grid">
          <div class="trending-toy-card" v-for="toy in toys" :key="toy.id">
            <!-- Left Side -->
            <div class="toy-image">
              <img :src="toy.image" :alt="toy.name" />

              <!-- Action buttons -->
              <div class="action-btns">
                <button class="like-btn">❤</button>
                <button class="view-btn">👁</button>
              </div>
            </div>

            <!-- Right Side -->
            <div class="toy-details">
              <h3>{{ toy.name }}</h3>
              <span class="toy-seller">{{ toy.seller }}</span>
              <p class="toy-price">${{ toy.price }}</p>

              <div class="toy-rating">
                <span v-for="star in 5" :key="star" class="star">{{
                  star <= toy.rating ? "★" : "☆"
                }}</span>
                <span class="rating-value">{{ toy.rating.toFixed(1) }}</span>
                <span class="rating-count">({{ toy.reviews }})</span>
              </div>
              <button class="cart-btn">
                🛒 ADD TO CART
                <small>Tap to add</small>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        class="mt-2"
        :style="`color: ${footerTextColor}; background: ${footerBgColor}; padding-top: 2rem;`"
      >
        <div class="footer-container">
          <!-- Middle Sections -->
          <div class="footer-links">
            <div class="footer-column">
              <img
                :src="appIcon || 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSmMFUr4TWHqkYckkiJqqEqBFqYy9gQKQ7N3w&s'"
  alt="logo"
                class="footer-logo"
              />
              <div class="tag-line">{{ tagLine }}</div>
              <ul class="footer-contact">
                <li>
                  <i class="fas fa-map-marker-alt"></i>
                  Austin, Austin, Texas, 73301
                </li>
                <li>
                  <i class="fas fa-phone"></i>
                  (+1) 250-456-2966
                </li>
                <li>
                  <i class="fas fa-envelope"></i>
                  eshita90roy@gmail.com
                </li>
              </ul>
            </div>
            <div class="footer-column">
              <h4><i class="fas fa-user"></i> MY ACCOUNT</h4>
              <ul>
                <li><i class="fas fa-user"></i> My Account</li>
                <li><i class="fas fa-box"></i> Order History</li>
                <li><i class="fas fa-heart"></i> Wish List</li>
                <li><i class="fas fa-envelope-open-text"></i> Contact Us</li>
              </ul>
            </div>

            <div class="footer-column">
              <h4><i class="fas fa-question-circle"></i> HELP & SUPPORT</h4>
              <ul>
                <li><i class="fas fa-question"></i> FAQ</li>
                <li><i class="fas fa-file-alt"></i> Terms & Conditions</li>
                <li><i class="fas fa-lock"></i> Privacy Policy</li>
                <li><i class="fas fa-info-circle"></i> About Us</li>
              </ul>
            </div>

            <div class="footer-column">
              <h4><i class="fas fa-gamepad"></i> TOY CATEGORIES</h4>
              <ul>
                <li>
                  <i class="fas fa-puzzle-piece"></i> Action & Collectibles
                </li>
                <li><i class="fas fa-baby"></i> Baby & Toddler</li>
                <li><i class="fas fa-cubes"></i> Building Sets</li>
                <li><i class="fas fa-paint-brush"></i> Creative & DIY</li>
                <li><i class="fas fa-child"></i> Dolls & Role Play</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="footer-bottom">
          <p>© 2025 <span class="brand">Toytopia</span></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Note The icon need to be black for colour change to work

class Color {
  constructor(r, g, b) {
    this.set(r, g, b);
  }

  toString() {
    return `rgb(${Math.round(this.r)}, ${Math.round(this.g)}, ${Math.round(
      this.b
    )})`;
  }

  set(r, g, b) {
    this.r = this.clamp(r);
    this.g = this.clamp(g);
    this.b = this.clamp(b);
  }

  hueRotate(angle = 0) {
    angle = (angle / 180) * Math.PI;
    const sin = Math.sin(angle);
    const cos = Math.cos(angle);

    this.multiply([
      0.213 + cos * 0.787 - sin * 0.213,
      0.715 - cos * 0.715 - sin * 0.715,
      0.072 - cos * 0.072 + sin * 0.928,
      0.213 - cos * 0.213 + sin * 0.143,
      0.715 + cos * 0.285 + sin * 0.14,
      0.072 - cos * 0.072 - sin * 0.283,
      0.213 - cos * 0.213 - sin * 0.787,
      0.715 - cos * 0.715 + sin * 0.715,
      0.072 + cos * 0.928 + sin * 0.072,
    ]);
  }

  grayscale(value = 1) {
    this.multiply([
      0.2126 + 0.7874 * (1 - value),
      0.7152 - 0.7152 * (1 - value),
      0.0722 - 0.0722 * (1 - value),
      0.2126 - 0.2126 * (1 - value),
      0.7152 + 0.2848 * (1 - value),
      0.0722 - 0.0722 * (1 - value),
      0.2126 - 0.2126 * (1 - value),
      0.7152 - 0.7152 * (1 - value),
      0.0722 + 0.9278 * (1 - value),
    ]);
  }

  sepia(value = 1) {
    this.multiply([
      0.393 + 0.607 * (1 - value),
      0.769 - 0.769 * (1 - value),
      0.189 - 0.189 * (1 - value),
      0.349 - 0.349 * (1 - value),
      0.686 + 0.314 * (1 - value),
      0.168 - 0.168 * (1 - value),
      0.272 - 0.272 * (1 - value),
      0.534 - 0.534 * (1 - value),
      0.131 + 0.869 * (1 - value),
    ]);
  }

  saturate(value = 1) {
    this.multiply([
      0.213 + 0.787 * value,
      0.715 - 0.715 * value,
      0.072 - 0.072 * value,
      0.213 - 0.213 * value,
      0.715 + 0.285 * value,
      0.072 - 0.072 * value,
      0.213 - 0.213 * value,
      0.715 - 0.715 * value,
      0.072 + 0.928 * value,
    ]);
  }

  multiply(matrix) {
    const newR = this.clamp(
      this.r * matrix[0] + this.g * matrix[1] + this.b * matrix[2]
    );
    const newG = this.clamp(
      this.r * matrix[3] + this.g * matrix[4] + this.b * matrix[5]
    );
    const newB = this.clamp(
      this.r * matrix[6] + this.g * matrix[7] + this.b * matrix[8]
    );
    this.r = newR;
    this.g = newG;
    this.b = newB;
  }

  brightness(value = 1) {
    this.linear(value);
  }
  contrast(value = 1) {
    this.linear(value, -(0.5 * value) + 0.5);
  }

  linear(slope = 1, intercept = 0) {
    this.r = this.clamp(this.r * slope + intercept * 255);
    this.g = this.clamp(this.g * slope + intercept * 255);
    this.b = this.clamp(this.b * slope + intercept * 255);
  }

  invert(value = 1) {
    this.r = this.clamp((value + (this.r / 255) * (1 - 2 * value)) * 255);
    this.g = this.clamp((value + (this.g / 255) * (1 - 2 * value)) * 255);
    this.b = this.clamp((value + (this.b / 255) * (1 - 2 * value)) * 255);
  }

  hsl() {
    // Code taken from https://stackoverflow.com/a/9493060/2688027, licensed under CC BY-SA.
    const r = this.r / 255;
    const g = this.g / 255;
    const b = this.b / 255;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    let h,
      s,
      l = (max + min) / 2;

    if (max === min) {
      h = s = 0;
    } else {
      const d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
        case r:
          h = (g - b) / d + (g < b ? 6 : 0);
          break;

        case g:
          h = (b - r) / d + 2;
          break;

        case b:
          h = (r - g) / d + 4;
          break;
      }
      h /= 6;
    }

    return {
      h: h * 100,
      s: s * 100,
      l: l * 100,
    };
  }

  clamp(value) {
    if (value > 255) {
      value = 255;
    } else if (value < 0) {
      value = 0;
    }
    return value;
  }
}

class Solver {
  constructor(target, baseColor) {
    this.target = target;
    this.targetHSL = target.hsl();
    this.reusedColor = new Color(0, 0, 0);
  }

  solve() {
    const result = this.solveNarrow(this.solveWide());
    return {
      values: result.values,
      loss: result.loss,
      filter: this.css(result.values),
    };
  }

  solveWide() {
    const A = 5;
    const c = 15;
    const a = [60, 180, 18000, 600, 1.2, 1.2];

    let best = { loss: Infinity };
    for (let i = 0; best.loss > 25 && i < 3; i++) {
      const initial = [50, 20, 3750, 50, 100, 100];
      const result = this.spsa(A, a, c, initial, 1000);
      if (result.loss < best.loss) {
        best = result;
      }
    }
    return best;
  }

  solveNarrow(wide) {
    const A = wide.loss;
    const c = 2;
    const A1 = A + 1;
    const a = [0.25 * A1, 0.25 * A1, A1, 0.25 * A1, 0.2 * A1, 0.2 * A1];
    return this.spsa(A, a, c, wide.values, 500);
  }

  spsa(A, a, c, values, iters) {
    const alpha = 1;
    const gamma = 0.16666666666666666;

    let best = null;
    let bestLoss = Infinity;
    const deltas = new Array(6);
    const highArgs = new Array(6);
    const lowArgs = new Array(6);

    for (let k = 0; k < iters; k++) {
      const ck = c / Math.pow(k + 1, gamma);
      for (let i = 0; i < 6; i++) {
        deltas[i] = Math.random() > 0.5 ? 1 : -1;
        highArgs[i] = values[i] + ck * deltas[i];
        lowArgs[i] = values[i] - ck * deltas[i];
      }

      const lossDiff = this.loss(highArgs) - this.loss(lowArgs);
      for (let i = 0; i < 6; i++) {
        const g = (lossDiff / (2 * ck)) * deltas[i];
        const ak = a[i] / Math.pow(A + k + 1, alpha);
        values[i] = fix(values[i] - ak * g, i);
      }

      const loss = this.loss(values);
      if (loss < bestLoss) {
        best = values.slice(0);
        bestLoss = loss;
      }
    }
    return { values: best, loss: bestLoss };

    function fix(value, idx) {
      let max = 100;
      if (idx === 2 /* saturate */) {
        max = 7500;
      } else if (idx === 4 /* brightness */ || idx === 5 /* contrast */) {
        max = 200;
      }

      if (idx === 3 /* hue-rotate */) {
        if (value > max) {
          value %= max;
        } else if (value < 0) {
          value = max + (value % max);
        }
      } else if (value < 0) {
        value = 0;
      } else if (value > max) {
        value = max;
      }
      return value;
    }
  }

  loss(filters) {
    // Argument is array of percentages.
    const color = this.reusedColor;
    color.set(0, 0, 0);

    color.invert(filters[0] / 100);
    color.sepia(filters[1] / 100);
    color.saturate(filters[2] / 100);
    color.hueRotate(filters[3] * 3.6);
    color.brightness(filters[4] / 100);
    color.contrast(filters[5] / 100);

    const colorHSL = color.hsl();
    return (
      Math.abs(color.r - this.target.r) +
      Math.abs(color.g - this.target.g) +
      Math.abs(color.b - this.target.b) +
      Math.abs(colorHSL.h - this.targetHSL.h) +
      Math.abs(colorHSL.s - this.targetHSL.s) +
      Math.abs(colorHSL.l - this.targetHSL.l)
    );
  }

  css(filters) {
    function fmt(idx, multiplier = 1) {
      return Math.round(filters[idx] * multiplier);
    }
    return `filter: invert(${fmt(0)}%) sepia(${fmt(1)}%) saturate(${fmt(
      2
    )}%) hue-rotate(${fmt(3, 3.6)}deg) brightness(${fmt(4)}%) contrast(${fmt(
      5
    )}%);`;
  }
}

export default {
  data() {
    return {
      currentIndex: 0,
      itemsPerPage: 4,
      categories: [
        {
          id: 1,
          name: "Action & Collectibles",
       icon: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSmMFUr4TWHqkYckkiJqqEqBFqYy9gQKQ7N3w&s",
     color: "#8B5CF6",
        },
        {
          id: 2,
          name: "Baby & Toddler",
       icon: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSmMFUr4TWHqkYckkiJqqEqBFqYy9gQKQ7N3w&s",
   color: "#EC4899",
        },
        {
          id: 3,
          name: "Building Sets",
       icon: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSmMFUr4TWHqkYckkiJqqEqBFqYy9gQKQ7N3w&s",
     color: "#F97316",
        },
        {
          id: 4,
          name: "Creative & DIY",
        icon: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSmMFUr4TWHqkYckkiJqqEqBFqYy9gQKQ7N3w&s",
     color: "#EAB308",
        },
        {
          id: 5,
          name: "Dolls & Role Play",
       icon: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSmMFUr4TWHqkYckkiJqqEqBFqYy9gQKQ7N3w&s",
     color: "#22C55E",
        },
        {
          id: 6,
          name: "Educational",
      icon: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSmMFUr4TWHqkYckkiJqqEqBFqYy9gQKQ7N3w&s",
     color: "#3B82F6",
        },
        {
          id: 7,
          name: "Outdoor & Sports",
    icon: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSmMFUr4TWHqkYckkiJqqEqBFqYy9gQKQ7N3w&s",
     color: "#EF4444",
        },
        {
          id: 8,
          name: "Plush Toys",
      icon: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSmMFUr4TWHqkYckkiJqqEqBFqYy9gQKQ7N3w&s",
    color: "#EF4444",
        },
        {
          id: 9,
          name: "RC & Vehicles",
       icon: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSmMFUr4TWHqkYckkiJqqEqBFqYy9gQKQ7N3w&s",
    color: "#EF4444",
        },
      ],
      toys: [
        {
          id: 1,
          name: "Musical toys",
          price: 10,
          image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSmMFUr4TWHqkYckkiJqqEqBFqYy9gQKQ7N3w&s",
          seller: "ESHITA",
          rating: 5.0,
          reviews: 25,
        },
        {
          id: 2,
          name: "Superhero",
          price: 5,
          image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSmMFUr4TWHqkYckkiJqqEqBFqYy9gQKQ7N3w&s",
          seller: "ESHITA",
          rating: 4.0,
          reviews: 49,
        },
        {
          id: 3,
          name: "Marvel Avengers Iron Man Action Figure toy",
          price: 15,
          image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSmMFUr4TWHqkYckkiJqqEqBFqYy9gQKQ7N3w&s",
          seller: "ESHITA",
          rating: 4.5,
          reviews: 50,
        },
        {
          id: 4,
          name: "Optimus Prime Action Figure toy",
          price: 15,
          image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSmMFUr4TWHqkYckkiJqqEqBFqYy9gQKQ7N3w&s",
          seller: "ESHITA",
          rating: 4.5,
          reviews: 50,
        },
      ],
    };
  },
  props: {
    font: {
      type: String,
      default: "",
    },
    primaryColor: {
      type: String,
      default: "#ffffff",
    },
    primaryTextColor: {
      type: String,
      default: "#000000",
    },
    primaryLightColor: {
      type: String,
      default: "#ffffff",
    },
    statusBar: {
      type: String,
      default: "#ffffff",
    },
    headerTop: {
      type: String,
      default: "#ffffff",
    },
    headerBottom: {
      type: String,
      default: "#ffffff",
    },
    headerFont: {
      type: String,
      default: "#ffffff",
    },
    footerBgColor: {
      type: String,
      default: "#ffffff",
    },
    footerTextColor: {
      type: String,
      default: "#ffffff",
    },
    appIcon: {
      type: String,
      default: null,
    },
    appName: {
      type: String,
      default: "App Name",
    },
    tagLine: {
      type: String,
      default: "",
    },
    btnColour: {
      type: String,
      default: "#0b4990",
    },
    headerCartIcon: {
      type: Boolean,
      default: true,
    },
    headerWishlistIcon: {
      type: Boolean,
      default: true,
    },
    headerNavs: {
      type: Boolean,
      default: true,
    },
    businessKeyPoints: {
      type: Boolean,
      default: true,
    },
    categorySection: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    nextSlide() {
      if (this.currentIndex < this.categories.length - this.itemsPerPage) {
        this.currentIndex += 1;
      }
    },
    previousSlide() {
      if (this.currentIndex > 0) {
        this.currentIndex -= 1;
      }
    },
    goToDot(dotIndex) {
      this.currentIndex = dotIndex * this.itemsPerPage;
    },
    hexToRgb(hex) {
      // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
      const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
      hex = hex.replace(shorthandRegex, (m, r, g, b) => {
        return r + r + g + g + b + b;
      });

      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result
        ? [
            parseInt(result[1], 16),
            parseInt(result[2], 16),
            parseInt(result[3], 16),
          ]
        : null;
    },
    changeToColor(col) {
      const rgb = this.hexToRgb(col);

      const color = new Color(rgb[0], rgb[1], rgb[2]);
      const solver = new Solver(color);
      const result = solver.solve();
      return result.filter;
    },

    //based on the button background hex color, calculate the luminance/ brightness of the color
    getLuminance(hexColor) {
      const rgb = this.hexToRgb(hexColor);
      if (!rgb) return 0;

      // Calculate relative luminance using WCAG formula
      const [r, g, b] = rgb.map((c) => {
        c = c / 255;
        return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
      });
      return 0.2126 * r + 0.7152 * g + 0.0722 * b;
    },
  },
  computed: {
    visibleCategories() {
      return this.categories.slice(
        this.currentIndex,
        this.currentIndex + this.itemsPerPage
      );
    },
    totalDots() {
      return Math.ceil(this.categories.length / this.itemsPerPage);
    },
    currentDot() {
      return Math.floor(this.currentIndex / this.itemsPerPage);
    },
    buttonTextColor() {
      const luminance = this.getLuminance(this.btnColour);
      return luminance > 0.5 ? "#000000" : "#ffffff";
    },
    buttonStyle() {
      return {
        "--btn-color": this.btnColour,
        "--btn-text-color": this.buttonTextColor,
        "--primary-color": this.primaryColor,
        "--secondary-color": this.headerTop,
        "--primary-light-color": this.primaryLightColor,
        "--primary-text-color": this.primaryTextColor,
        "--footer-bg-color": this.footerBgColor,
        "--footer-text-color": this.footerTextColor,
      };
    },
    headerIconStyle() {
      return this.changeToColor(this.primaryTextColor);
    },
    // footerNormalStyle() {
    //   return this.changeToColor(this.footerNormal);
    // },
    // footerSelStyle() {
    //   return this.changeToColor(this.footerSelection);
    // },
    splashBGStyle() {
      if (this.splashBGImage) {
        return `background-image:url(${this.splashBGImage});background-color:${this.splashBGCol};`;
      }
      return `background:${this.splashBGCol};`;
    },
  },
  mounted() {
    this.changeToColor("#aa44bb");
  },
};
</script>

<style lang="scss" scoped>
.amazing-toys-section {
  margin-top: 1rem;
  padding: 1rem;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.section-title {
  font-size: 16px;
  font-weight: 700;
}

.see-more-btn {
  background: linear-gradient(
    135deg,
    var(--primary-color),
    var(--secondary-color)
  );
  border: none;
  padding: 0.6rem 1.4rem;
  border-radius: 25px;
  font-size: 9px;
  font-weight: 600;
  color: #444;
  cursor: pointer;
  transition: transform 0.3s ease, color 0.3s ease;
  &:hover {
    background: var(--primary-color);
    transform: scale(1.1);
  }
}

.toys-row {
  display: flex;
  gap: 1rem;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.toy-card {
  flex: 1 1 calc(50% - 1rem);
  box-sizing: border-box;
  border: 2px solid var(--primary-light-color);
  transition: transform 0.3s ease, color 0.3s ease;
  display: flex;
  background: #fffdf9;
  border-radius: 20px;
  box-shadow: 0 8px 18px var(--primary-light-color);
  width: 100%;
  align-items: center;
  justify-content: space-between;
  &:hover {
    transform: translateY(-5px);
    border: 2px solid var(--primary-color);
    cursor: pointer;
  }
}
.trending-toy-card {
  // flex: 1 1 calc(50% - 1rem);
  box-sizing: border-box;
  border: 2px solid var(--primary-light-color);
  transition: transform 0.3s ease, color 0.3s ease;
  display: flex;
  background: #fffdf9;
  border-radius: 20px;
  box-shadow: 0 8px 18px var(--primary-light-color);
  width: 100%;
  align-items: center;
  justify-content: space-between;

  &:hover {
    transform: translateY(-5px);
    border: 2px solid var(--primary-color);
    cursor: pointer;
  }
}

.toy-details {
  // background-color: var(--primary-light-color);
  border-radius: 0px 16px 16px 0px;
  flex: 1.2;
  text-align: left;
  padding: 0.5rem;
}
.toy-details h3 {
  font-size: 0.8rem;
  font-weight: bold;
}

.toy-name {
  font-size: 9px;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.toy-seller {
  display: inline-block;
  font-size: 9px;
  padding: 0.2rem 0.5rem;
  border-radius: 6px;
  margin-bottom: 0.3rem;
  background: var(--primary-color);
  color: var(--btn-text-color);
}
.toy-price {
  font-size: 12px;
  font-weight: 600;
  color: var(--primary-text-color);
  margin-bottom: 0.2rem;
}

.toy-rating {
  font-size: 9px;
  color: yellow;
  margin-bottom: 0.8rem;
}

.toy-rating .rating-value {
  font-weight: bold;
  color: var(--primary-text-color);
  margin-left: 0.3rem;
}

.toy-rating .rating-count {
  color: var(--primary-text-color);
  font-size: 9px;
  margin-left: 0.2rem;
}

.laptop-body {
  width: 500px;
  height: 290px;
  background: white;
  position: relative;
  z-index: 10;
  font-size: 9px;
  overflow-y: auto; // Changed from overflow: hidden
  overflow-x: hidden; // Prevent horizontal scrolling
}

.header-mob {
  padding: 0.5rem;
  width: 100%;
  height: 40px;
  border-radius: 0;
  display: flex;
  align-items: center;
  justify-content: space-around;
  box-shadow: 0px 2.2637px 5.65925px rgba(0, 0, 0, 0.15);
}
.header-icons {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: 12px;
  color: var(--primary-text-color);
  cursor: pointer;

  i {
    transition: transform 0.3s ease, color 0.3s ease;
    padding: 0.2rem;
    border-radius: 3px;
    &:hover {
      background: var(--primary-color);
      color: var(--primary-light-color);
      transform: scale(1.2);
    }
  }
}

.sales-advertisement {
  margin: 0px auto;
  display: block;
  height: 180px;
}

img.sales-advertisement {
  width: 100%;
}

.laptop-frame {
  position: absolute;
  z-index: 2;
  bottom: -59px;
  left: -122.5px;

  img {
    display: block;
    width: 745px;
    height: 358px;
    object-fit: fill;
  }
}

.app-logo {
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: bold;
  font-size: 12px;
  transition: transform 0.3s ease;

  img {
    height: 25px;
    cursor: pointer;
    padding-right: 12px;
    transition: transform 0.3s ease;
  }
  &:hover {
    transform: rotateY(20deg);
  }
}
.location-selector {
  margin-right: 12px;
  border-radius: 6px;
  border: 1px solid var(--primary-color);
  select {
    padding: 6px 12px;
  }

  &:hover {
    border: 1px solid var(--primary-light-color);
    background-color: var(--primary-color);
  }
}

.advertisement {
  position: relative;
  cursor: pointer;
}

.laptop-body::-webkit-scrollbar {
  width: 6px;
}

.laptop-body::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.laptop-body::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 3px;
}

.laptop-body::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.toy-categories {
  max-width: 1200px;
  margin: 0 auto;
  padding: 1rem;
  text-align: center;
}

.header-section {
  margin-bottom: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.title {
  font-size: 9px;
  font-weight: 700;
  margin-bottom: 0.5rem;
}

.subtitle {
  font-size: 9px;
  font-weight: 700;
  margin: 0;
}

.carousel-container {
  position: relative;
  width: 100%;
}

.carousel-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: #fff;
  border: none;
  border-radius: 50%;
  box-shadow: 0 2px 6px var(--primary-text-color);
  width: 25px;
  height: 25px;
  cursor: pointer;
  font-size: 12px;
  font-weight: bold;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
}

.carousel-btn.left {
  left: -12px;
  padding-bottom: 4px;
  z-index: 10;
  border: 1px solid var(--primary-light-color);

  &:hover {
    border: 1px solid var(--primary-color);
  }
}

.carousel-btn.right {
  right: -12px;
  padding-bottom: 4px;
  border: 1px solid var(--primary-light-color);
  &:hover {
    border: 1px solid var(--primary-color);
  }
}

.carousel-btn:hover {
  transform: translateY(-50%) scale(1.1);
}

.categories-grid {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.category-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  width: 150px; /* Set a fixed width */
  height: 90px; /* Set a fixed height */
  transition: transform 0.3s ease;
  border: 2px solid var(--primary-light-color);
  background: linear-gradient(
    135deg,
    var(--primary-color),
    var(--secondary-color)
  );
  border-radius: 8px;
  padding: 10px;
  cursor: pointer;
  &:hover {
    border: 2px solid var(--primary-color);
  }
}

.category-item:hover {
  transform: translateY(-4px);
}

.category-circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 2px solid;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.category-circle:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transform: scale(1.05);
}

.category-icon {
  width: 48px;
  height: 48px;
  object-fit: contain;
}

.category-name {
  font-size: 9px;
  font-weight: 600;
  margin: 0;
  // max-width: 100px;
  text-align: center;
  line-height: 1.2;
}

.carousel-dots {
  margin-top: 2rem;
  display: flex;
  gap: 0.5rem;
  justify-content: center;
  align-items: center;
}

.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #f97316;
  opacity: 0.3;
  transition: opacity 0.3s ease;
}

.dot.active {
  opacity: 1;
}

@media (max-width: 768px) {
  .toy-categories {
    padding: 1rem;
  }

  .title {
    font-size: 9px;
  }

  .categories-grid {
    gap: 1rem;
  }

  .category-circle {
    width: 60px;
    height: 60px;
  }

  .category-icon {
    width: 36px;
    height: 36px;
  }

  .category-name {
    font-size: 9px;
    max-width: 80px;
  }
}
.search-bar {
  flex: 1;
  display: flex;
  align-items: center;
  border: 1px solid var(--primary-color);
  border-radius: 6px;
  overflow: hidden;

  input {
    &:hover {
      background-color: var(--primary-color);
    }
  }

  &:hover {
    border: 1px solid var(--primary-light-color);
  }
}
.search-bar input {
  min-width: 0; // prevents overflow in flexbox
  border: none;
  outline: none;
  flex: 1;
  padding: 6px 12px;
}
.search-bar button {
  white-space: nowrap;
  border: none;
  padding: 6px 16px;
  background: linear-gradient(
    to right,
    var(--secondary-color),
    var(--primary-color)
  );
  color: white;
  font-weight: bold;
  cursor: pointer;
}

.trending-toys {
  text-align: center;
  padding: 2rem 1rem;
}
.trending-header {
  text-align: center;
}
.trending-header h2 {
  font-size: 1rem;
  font-weight: bold;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}
.trending-header p {
  margin-top: 0.5rem;
  color: var(--btn-text-color);
}

.trending-header {
  text-align: center;
}

.section-header h2 {
  font-size: 1rem;
  font-weight: bold;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

/* Flex Grid for 2 cards per row */
.toys-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
  justify-content: center;
  margin-top: 2rem;
}

.toy-image {
  flex: 1;
  position: relative;
  text-align: center;
}
.toy-image img {
  max-width: 100px;
  border-radius: 8px;
  padding: 0.2rem;
}

.action-btns {
  position: absolute;
  bottom: 30px;
  right: 10px;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.action-btns button {
  border-radius: 50%;
  border: 1px solid var(--primary-light-color);
  background: var(--primary-color);
  color: var(--btn-text-color);
  padding: 0.3rem;
  cursor: pointer;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.1);
  }
}
.like-btn {
  &:hover {
    color: red;
  }
}
.view-btn {
  &:hover {
    color: white;
  }
}

.brand {
  display: inline-block;
  padding: 0.2rem 0.6rem;
  border-radius: 8px;
  font-size: 0.9rem;
  margin-top: 0.4rem;
  font-weight: bold;
}
.rating {
  margin: 0.5rem 0;
  color: #ffb703;
}
.rating-score {
  margin-left: 5px;
  color: #e63946;
  font-weight: bold;
}
.reviews {
  color: #555;
  font-size: 0.9rem;
  margin-left: 3px;
}

.cart-btn {
  width: 100%;
  padding: 0.4rem;
  border: 1px solid var(--primary-light-color);
  border-radius: 10px;
  background: linear-gradient(
    to right,
    var(--secondary-color),
    var(--primary-color)
  );
  font-weight: bold;
  cursor: pointer;
  font-size: 0.6rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: transform 0.3s ease;

  &:hover {
    border: 1px solid var(--primary-color);
    transform: scale(1.05);
    background: var(--primary-color);
    color: var(--btn-text-color);
  }
}
.cart-btn small {
  font-size: 0.5rem;
  opacity: 0.8;
}
.footer-container {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.footer-logo {
  width: 40px;
  margin-bottom: 10px;
}
.footer-company {
  // color: #ff7f50;
  font-weight: bold;
  margin-bottom: 15px;
}
.footer-contact li {
  margin: 6px 0;
  list-style: none;
}
.footer-contact i {
  margin-right: 8px;
  // color: #ff6b57;
}

.footer-links {
  flex: 2;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
}
.footer-column {
  margin: 2px;
}
.footer-column h4 {
  font-size: 12px;
  font-weight: bold;
  color: var(--primary-color);
  margin-bottom: 10px;
}
.footer-column ul {
  padding: 0;
}
.footer-column li {
  list-style: none;
  margin: 6px 0;
  cursor: pointer;
  transition: 0.2s;
}
.footer-column li i {
  margin-right: 6px;
}
.footer-column li:hover {
  color: var(--primary-light-color);
}

.footer-bottom {
  text-align: center;
  font-size: 14px;
  border-top: 1px solid #f5dcdc;
  margin-top: 20px;
  padding: 10px 0;
}
</style>
